import React, { useState } from 'react'
import { useLocation, Outlet } from 'react-router-dom'

import { Place } from '../../types/utils'

import BreadCrumbs from '../BreadCrumbs'
import PageNav from '../PageNav'
import UnclaimModal from './UnclaimModal'
import { useUser } from '../../hooks/useUser'

type ClaimedViewProps = {
  data: Place
}

const ClaimedView: React.FC<ClaimedViewProps> = (props) => {
  const { pathname } = useLocation()
  const [open, setOpen] = useState(false)
  const user = useUser()
  const canBuzzlUserEdit =
    (user.data?.type === 'BUZZL' && user.data.role === 'ADMIN') || //admin users can edit everything
    (user.data?.type === 'BUZZL' &&
      user.data.role === 'OPERATOR' &&
      user.data.buzzlUser?.assignedCustomers &&
      user?.data?.buzzlUser?.assignedCustomers?.length < 1) || //operator users with no assigned customer can edit everything
    user.data?.buzzlUser?.assignedCustomers?.some((customer) => customer.id === props.data.customer?.id) // if the customer is assigned to a buzzl user they can edit its location

  const handleClose = () => {
    setOpen(false)
  }

  const breadCrumbPages = [
    { name: 'Locations', href: '/locations' },
    { name: props.data.name, href: pathname },
  ]

  const navigation = [
    { name: 'Details', href: `/locations/${props.data.id}` },
    { name: 'Experiences', href: `/locations/${props.data.id}/experiences` },
    { name: 'Rewards', href: `/locations/${props.data.id}/rewards` },
  ]

  return (
    <div>
      <BreadCrumbs breadCrumbPages={breadCrumbPages} />
      <UnclaimModal placeId={props.data.id} open={open} onClose={handleClose} />
      <h1 className="text-lg font-medium leading-6 text-gray-900">{props.data.name}</h1>
      <div className="flex items-start justify-between">
        <div className="flex-1 md:mr-5">
          <PageNav navigation={navigation} />
        </div>
        {canBuzzlUserEdit ? (
          <div>
            <button className="btn btn-secondary" onClick={() => setOpen(true)}>
              Unclaim
            </button>
          </div>
        ) : null}
      </div>
      <Outlet context={props.data} />
    </div>
  )
}

export default ClaimedView
